<ng-template #dialogTemplate>
  <mat-dialog-content i18n>
    У вас есть несохраненные изменения. Вы действительно хотите выйти?
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close class="gl-mar-r16">
      {{ stringsService.strings.cancel }}
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      {{ stringsService.strings.continue }}
    </button>
  </mat-dialog-actions>
</ng-template>
